"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
exports.configStore = {};
exports.replaceConfigStore = (newConfigStore) => {
    exports.configStore = immer_1.default(exports.configStore, () => {
        return newConfigStore;
    });
};
